import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
class AdjustmentApi extends Requestor {
    /**
     * 상점 정산 - 정산 내역서 조회
     */
    getStoreAdjustmentDetail(hubId, storeId, params = {}) {
        return this.get({
            url: `/api/v1/adjustment/reports/hubs/${hubId}/stores/${storeId}`,
            params,
        });
    }
    /**
     * 상점 정산 목록 조회
     * @param {Object} params
     * @returns {Object}
     */
    getStoreAdjustment(hubId, params = {}) {
        return this.get({
            url: `/api/v1/adjustment/reports/hubs/${hubId}/stores`,
            params,
        });
    }
    /**
     * 라이더 정산 - 이행 상황 신고
     */
    getWorkerAdjustmentWithhold(hubId, params = {}) {
        return this.get({
            url: `/api/v1/adjustment/reports/hubs/${hubId}/workers/withhold-tax`,
            params,
        });
    }
    /**
     * 허브 바로머니 리포트 (BASIC) 정보 조회
     * @param {Object} params
     * @returns {Object}
     */
    getBasicBaromoneyReport(hubId, params = {}) {
        return this.get({
            url: `/api/v1/adjustment/reports/hubs/${hubId}/basic`,
            params,
        });
    }
    getHubMainReport(hubId, params = {}) {
        return this.get({
            url: `/api/v1/adjustment/hubs/${hubId}/report/sales-purchase`,
            params,
        });
    }
    /**
     * 허브 정산 - 타입별 정산 내역서 조회
     */
    getHubAdjustmentReportByType(hubId, reportType, params = {}) {
        return this.get({
            url: `/api/v1/adjustment/hubs/${hubId}/report/${reportType}`,
            params,
        });
    }
}
export default new AdjustmentApi(clientInstance);
